/**
 * Whether a plan is the surgeon's clinical decision, or a proposal prepared for them.
 *
 * Preparing a plan is delegable work; approving one is the clinical act the surgeon carries
 * liability for. Before proposing existed the two were the same thing, so a plan row existing
 * meant a surgeon had accepted it. That is no longer true.
 */
export const planApprovalStates = ['proposed', 'approved'] as const;

export type PlanApprovalState = (typeof planApprovalStates)[number];

export function isPlanApprovalState(value: string): value is PlanApprovalState {
    return planApprovalStates.includes(value as PlanApprovalState);
}
